module.exports = __webpack_public_path__ + "img/a6.edad5834.png";